import { PropsWithChildren, useState } from "react";

import { FinishReviewDialog } from "@components/ReportReview/FinishReviewDialog";
import { Decision, FinishReviewContext, FinishReviewValue } from "@components/ReportReview/hooks/useFinishReview";

/** Owns the dialog so the toolbar button and the reviewer menu items open the same one. */
export const FinishReviewProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [decision, setDecision] = useState<Decision>();
  const [note, setNote] = useState("");

  const value: FinishReviewValue = {
    open,
    setOpen,
    decision,
    setDecision,
    note,
    setNote,
    // Each opening starts from the menu item's choice, or none so the dialog picks from the reviewer's comments.
    openFinishReview: (next) => {
      setDecision(next);
      setOpen(true);
    },
    // The choice is left as is so the closing dialog doesn't flip it; the next opening resets it.
    discard: () => {
      setNote("");
      setOpen(false);
    },
  };

  return (
    <FinishReviewContext value={value}>
      {children}
      <FinishReviewDialog />
    </FinishReviewContext>
  );
};
